/* eslint-disable jsx-a11y/label-has-for */
import React from 'react';
import Spinner from 'react-spinkit';
import PropTypes from 'prop-types';
import cx from 'classnames';
import visa from 'payment-icons/min/single/visa.svg';
import mastercard from 'payment-icons/min/single/mastercard.svg';
import amex from 'payment-icons/min/single/amex.svg';
import discover from 'payment-icons/min/single/discover.svg';
import diners from 'payment-icons/min/single/diners.svg';
import jcb from 'payment-icons/min/single/jcb.svg';
import unionpay from 'payment-icons/min/single/unionpay.svg';
import unknown from 'payment-icons/min/mono/default.svg';

import Money from '../../components/Money';
import InputZip from '../../components/InputZip';

const brandIcons = {
  visa,
  mastercard,
  amex,
  discover,
  diners,
  jcb,
  unionpay,
  unknown,
};

const PaymentForm = ({
  amount,
  panelLabel,
  submit,
  formDisabled,
  zipCode,
  setZipCode,
  cardNumberId,
  cardExpiryId,
  cardCvcId,
  zipCodeId,
  cardBrand,
  stripeInputErrors,
  hasErrors,
  isCoveredByDiscount,
  hasApplePay,
  toggleApplePay,
  shopCountry,
  zipCodeBlur,
  submitEnabled,
  title,
  buttonLabel,
}) => (
  <form
    className={cx('c-card-information u-flex u-flex-column', { 'c-card-information--discounted': isCoveredByDiscount })}
    onSubmit={submit}
  >
    <div className="c-payment-modal-heading u-mb">{title}</div>
    <div className="u-flex-1 u-flex u-flex-column u-justify-content-space-between">
      <div>
        <label className="c-checkout-modal__input-label u-mb" id="cardNumberInputLabel">
          <div>Card Number</div>
          <div className="StripeElement StripeCardNumberElement u-position-relative">
            {
              brandIcons[cardBrand] && cardBrand !== 'unknown' && (
                <span className="c-checkout-modal__card-number-brand">
                  <img src={brandIcons[cardBrand]} alt={cardBrand} />
                </span>
              )
            }
            {
              (!brandIcons[cardBrand] || cardBrand === 'unknown') && (
                <span className="c-checkout-modal__card-number-brand c-checkout-modal__card-number-brand_default">
                  <img src={brandIcons.unknown} alt={cardBrand} />
                </span>
              )
            }
            <div id={cardNumberId} />
          </div>
          {stripeInputErrors.cardNumber && (
            <div className="c-checkout-modal__input-error u-co-red">
              {stripeInputErrors.cardNumber}
            </div>
          )}
        </label>
        <div className="c-checkout-modal__input-group u-mb--">
          <label className="c-checkout-modal__input-label">
            <div>Exp. Date</div>
            <div id={cardExpiryId} className="StripeElement" />
            {stripeInputErrors.cardExpiry && (
              <div className="c-checkout-modal__input-error u-co-red">
                {stripeInputErrors.cardExpiry}
              </div>
            )}
          </label>
          <label className="c-checkout-modal__input-label">
            <div>CVC</div>
            <div id={cardCvcId} className="StripeElement" />
            {stripeInputErrors.cardCvc && (
              <div className="c-checkout-modal__input-error u-co-red">
                {stripeInputErrors.cardCvc}
              </div>
            )}
          </label>
          <label className="c-checkout-modal__input-label">
            <div>ZIP / Postal</div>
            <InputZip
              country={shopCountry}
              id={zipCodeId}
              className="StripeElement"
              placeholder="ZIP/Postal Code"
              value={zipCode}
              onChange={setZipCode}
              disabled={formDisabled}
              onBlur={zipCodeBlur}
            />
            {stripeInputErrors.zipCode && (
              <div className="c-checkout-modal__input-error c-checkout-modal__input-error_top u-co-red">
                {stripeInputErrors.zipCode}
              </div>
            )}
          </label>
        </div>
      </div>
      {
        !isCoveredByDiscount && (
          <button className="c-button" disabled={!submitEnabled || (formDisabled || hasErrors)}>
            {
              formDisabled
                ? <Spinner name="three-bounce" className="c-checkout-modal__spinner" noFadeIn />
                : (
                  <span>
                    {buttonLabel ||
                    <span>{panelLabel}&nbsp;
                      {Number(amount) && <Money>{amount}</Money>}
                    </span>}
                  </span>
                )
            }
          </button>
        )
      }
      {
        isCoveredByDiscount && (
          <button className="c-button">
            Process
          </button>
        )
      }
      {
        !isCoveredByDiscount && hasApplePay && (<button
          type="button"
          className="c-btn-link c-btn-link--small u-mt- u-co-black-3 u-font-weight-normal"
          onClick={toggleApplePay}
        >
          Or pay with Apple pay
        </button>)
      }
    </div>
  </form>
);

PaymentForm.propTypes = {
  formDisabled: PropTypes.bool.isRequired,
  amount: PropTypes.number.isRequired,
  submit: PropTypes.func.isRequired,
  panelLabel: PropTypes.string,
  setZipCode: PropTypes.func.isRequired,
  zipCode: PropTypes.string.isRequired,
  cardNumberId: PropTypes.string.isRequired,
  cardExpiryId: PropTypes.string.isRequired,
  cardCvcId: PropTypes.string.isRequired,
  zipCodeId: PropTypes.string.isRequired,
  cardBrand: PropTypes.string.isRequired,
  stripeInputErrors: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  hasErrors: PropTypes.bool.isRequired,
  isCoveredByDiscount: PropTypes.bool.isRequired,
  hasApplePay: PropTypes.bool,
  toggleApplePay: PropTypes.func,
  shopCountry: PropTypes.string.isRequired,
  zipCodeBlur: PropTypes.func.isRequired,
  submitEnabled: PropTypes.bool.isRequired,
  title: PropTypes.string,
  buttonLabel: PropTypes.string,
};

PaymentForm.defaultProps = {
  panelLabel: 'Pay',
  hasApplePay: true,
  toggleApplePay: () => { },
  title: 'Payment Information',
  buttonLabel: '',
};

export default PaymentForm;



// WEBPACK FOOTER //
// ./src/app/reservation/components/PaymentFormStripe.jsx